<template>
  <v-container class="my-16 mx-auto">
    <h1>開催情報</h1>
    <AccessData />

    <!-- <h2 class="my-6 bg-green pa-3" style="text-align: center;">
      ニュー新橋ビル3F マップ
    </h2> 
    <AccessMap /> -->
    <v-divider
      :thickness="2"
      color="indigo-darken-4"
      class="border-opacity-50"
    ></v-divider>
    <h2 class="my-6" style="text-align: center;">◆注意事項◆</h2>
    <CautionText />
  </v-container>
</template>

<script>
  import AccessData from "./AccessData.vue";
  import CautionText from "./CautionText.vue";
  //import AccessMap from "./AccessMap.vue";

  export default {
    name: "App",
    components: {
      AccessData,
      CautionText,
      //    AccessMap,
    },
  };
</script>
